/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IShelterAuction,
  IShelterAuctionInterface,
} from "../IShelterAuction";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "shelterId_",
        type: "uint256",
      },
    ],
    name: "posByShelter",
    outputs: [
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "buyerGuildId",
        type: "uint256",
      },
    ],
    name: "positionByBuyer",
    outputs: [
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "bidIndex",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "sellerGuildId_",
        type: "uint256",
      },
    ],
    name: "positionBySeller",
    outputs: [
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class IShelterAuction__factory {
  static readonly abi = _abi;
  static createInterface(): IShelterAuctionInterface {
    return new Interface(_abi) as IShelterAuctionInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IShelterAuction {
    return new Contract(address, _abi, runner) as unknown as IShelterAuction;
  }
}
